import { NEW_SETTINGS }             from '../../constants/newSettings/new-settings.constant'
import { ORIENTATION }              from '../../constants/orientation/orientation.constant'
import { localStorageSupported }    from '../../functions/localStorage-supported.function'

/**
 * @file Defines the {@link Settings} class
 * @author Joe Thompson <joe.thompson@1x2network.com>
 * @version 1.0.23
 */

/** Class for handling settings */
 export class Settings {

    /**
     * Promise for when settings are initialised
     * @memberof Settings
     * @protected
     * @instance
     * @type {Promise<undefined>}
     */
    _promise

    /**
     * Function to resolve promise
     * @memberof Settings
     * @protected
     * @instance
     * @type {function}
     */
    _resolve
    
    /**
     * Object storing all settings
     * @memberof Settings
     * @protected
     * @instance
     * @type {object}
     */
    _settings

    /**
     * Initialize settings
     */
    constructor() {
        this._promise = new Promise(resolve => this._resolve = resolve)
    }

    /** Get promise */  get promise()  { return this._promise }
    /** Get settings */ get settings() { return this._settings }

    /** Get inverted */ inverted() { return this._settings['inverted__controls'] }

    /** Initialise new UI settings */
    init() {

        this._settings = Object.create(null) //Initialize settings object

        //Loop through all settings
        for (let s in NEW_SETTINGS) {

            let setting = NEW_SETTINGS[s] //Store current setting
            let id      = setting.id      //Store setting id
            let value   = setting.value   //Set initial value for setting

            //Retrieve setting page in iron dog framework
            let page = document.getElementById(`${setting.page}Page`)

            //Create label for checkbox
            let l1 = document.createElement('label')
            l1.classList.add('switch', ORIENTATION.orientation)

            //Create checkbox, set checked & append to label
            let checkbox = document.createElement('input')
            checkbox.setAttribute('type', 'checkbox')
            l1.appendChild(checkbox)

            //Create div for styling checkbox & append to label
            let div = document.createElement('div')
            div.classList.add('slider', 'round')
            l1.appendChild(div)

            //Create label for setting
            let l2 = document.createElement('label')
            l2.classList.add(ORIENTATION.orientation)
            l2.classList.add('switch__name')
            l2.innerHTML = Translate.do(setting.label)
            
            //Create list item for setting
            let li = document.createElement('li')
            li.classList.add(ORIENTATION.orientation)
            li.appendChild(l1)
            li.appendChild(l2)

            //If setting already been stored
            if (localStorageSupported() && localStorage.getItem(id)) {
                this._settings[id] = this.get(id) //Get setting from localStorage
            }

            //Setting not been stored
            else {
                this.set(id, value) //Add setting to localStorage
            }

            this._settings[id] = this.get(id)             //Update setting value
            checkbox.checked   = this.get(id)             //Check/uncheck checkbox depending on value
            setting.onChange.dispatch(this._settings[id]) //Dispatch setting value

            //On setting change
            div.addEventListener('touchend', e_ => {

                this.set(id, !e_.currentTarget.previousSibling.checked) //Update localStorage
                checkbox.checked    = !checkbox.checked                 //Update checkbox
                this._settings[id]  =   this.get(id)                    //Update setting value
                setting.onChange.dispatch(this._settings[id])           //Dispatch setting value
                framework.resize()                                      //Resize UI correctly

                //Prevent default behaviour of checkbox check NB: https://stackoverflow.com/questions/10610249/prevent-checkbox-from-ticking-checking-completely
                e_.preventDefault()
                e_.stopPropagation()
                return false

            })

            page.getElementsByTagName('ul')[0].appendChild(li) //Add setting

        }

        this.autoplay() //Add currency symbol to autoplay settings where needed

        this._resolve() //Resolve promise

    }

    /**
     * Get setting from localStorage
     * @param k_ - Key to access localStorage
     * @return {*} Value from localStorage
     */
    get(k_) {
        return localStorageSupported() ? JSON.parse(localStorage.getItem(k_).toLowerCase()) : false
    }

    /**
     * Stores item in localStorage
     * @param {string} k_ - Setting key
     * @param {string} v_ - Setting value
     */
    set(k_, v_) {
        localStorageSupported() && localStorage.setItem(k_, v_)
    }

    /** Adds currency symbol to autoplay settings where currency can be input */
    autoplay() {

        let autoPage = document.getElementById('autoPage') //Store iron dog autoplay settings node

        let ul  = autoPage.querySelector('ul')  //Retrieve autoplay settings list
        let li  = ul.querySelectorAll('li')     //Retrieve all settings
        
        //Loop through settings
        Array.from(li).map(v_ => {

            let input = v_.querySelector('.auto__input')    //Retrieve input element

            //If setting has an input element
            if (input) {

                let elem    = document.createElement('label')               //Create label to store currency symbol
                elem.classList.add('cur-sym', ORIENTATION.orientation)      //Add styling
                elem.innerHTML  = balanceManager_.geBalanceObj().currency   //Set currency symbol in label
                v_.insertBefore(elem, input)                                //Add currency symbol before input node

            }

        })

    }

}